import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 576, // Mobile
      sm: 768, // Ipad
      md: 992, // Ipad Landscape
      lg: 1200, // Notebook
      xl: 1400,
    },
    scrollBarWidth: 24,
  },
});
